import { AuthRangeResponse } from "../data-model/medicalPaOrdersModel";

export const updateJcodesWithCorrectDocRef = (
  authEntries: AuthRangeResponse[],
  identifier: string[],
  docType: string,
  docRef: string,
  docTitle: string,
  docUploadBy: string,
) => {
  const updatedJCodes = authEntries.map((authEntry) => {
    return {
      ...authEntry,
      j_codes: authEntry.j_codes?.map((jCode) => {
        if (identifier.includes(jCode.id ?? "")) {
          // Create new document object based on data model
          const newDocument = {
            doc_type: docType,
            doc_path: docRef,
            doc_title: docTitle,
            doc_upload_date: new Date().toISOString(),
            doc_upload_by: docUploadBy,
          };

          return {
            ...jCode, // Copy the whole j_code element
            documents: [
              ...(jCode.documents || []), // Preserve existing documents
              newDocument, // Add new document
            ],
          };
        }
        return jCode;
      }),
    };
  });

  return updatedJCodes;
};

export const removeDocumentFromJcode = (
  authEntries: AuthRangeResponse[],
  identifier: string,
  docType: string,
) => {
  const updatedJCodes = authEntries.map((authEntry) => {
    return {
      ...authEntry,
      j_codes: authEntry.j_codes?.map((jCode) => {
        if (jCode.id === identifier) {
          return {
            ...jCode, // Copy the whole j_code element
            documents:
              jCode.documents?.filter(
                (document) => document.doc_type !== docType,
              ) || [], // Remove documents with matching docType
          };
        }
        return jCode;
      }),
    };
  });

  return updatedJCodes;
};
